import { SlatePlugin } from '../../../../slatePlugins/slatePlugins.types';
import { TableElement, TablePluginOptions, TableRenderElementProps } from '../table/types';
import { RenderElementProps } from 'slate-react';
import * as React from 'react';

import { AdminTableReadOnly } from './components/readonly/AdminTableReadOnly';
import { AdminTableRow } from './components/readonly/AdminTableRow';
import { TableTDReadOnly } from './components/readonly/AdminTableTD';

// const AdminTableReadOnly = dynamicEditorComponent(
//   () =>
//     import(
//       /* webpackExports: "AdminTableReadOnly" */ './components/readonly/AdminTableReadOnly'
//     ).then((mod) => mod.AdminTableReadOnly),
//   {
//     ssr: true,
//     loading: ({ props }) => (
//       <table className="admin-table-container">
//         <tbody>{props?.children}</tbody>
//       </table>
//     ),
//   }
// );

// const AdminTableRow = dynamicEditorComponent(
//   () => import('./components/readonly/AdminTableRow').then((mod) => mod.AdminTableRow),
//   {
//     ssr: true,
//     loading: ({ props }) => <tr {...props?.attributes}>{props?.children}</tr>,
//     dependsOn: AdminTableReadOnly,
//   }
// );
//
// const TableTDReadOnly = dynamicEditorComponent(
//   () =>
//     import(/* webpackExports: "TableTDReadOnly" */ './components/readonly/AdminTableTD').then(
//       (mod) => mod.TableTDReadOnly
//     ),
//   {
//     ssr: true,
//     loading: ({ props }) => <td {...props?.attributes}>{props?.children}</td>,
//     dependsOn: AdminTableReadOnly,
//   }
// );

const defaultOptions: TablePluginOptions = {
  stickyHeaderOffset: 0,
};

const renderReadOnlyTable = (opts: TableRenderElementProps) => (props: RenderElementProps) => {
  const { element } = props;
  if (element.id) {
    switch (element.type) {
      case TableElement.TABLE: {
        return <AdminTableReadOnly {...props} {...opts} />;
      }
      case TableElement.TR: {
        return <AdminTableRow {...props} {...opts} />;
      }
      case TableElement.TH:
      case TableElement.TD: {
        return <TableTDReadOnly {...props} {...opts} />;
      }
      default:
    }
  }
  return undefined;
};

export const BlogTableReadOnlyPluginV2 = (opts: TablePluginOptions = {}): SlatePlugin => {
  const options = { ...defaultOptions, ...opts };

  return {
    renderElement: renderReadOnlyTable(options),
  };
};
